// extracted by mini-css-extract-plugin
export default {"teaPrepare":"TeaPrepare_teaPrepare__8KZxb","container":"TeaPrepare_container__FQWXa","title":"TeaPrepare_title__RdU3S","text":"TeaPrepare_text__rIRJW"};